export default "__VITE_ASSET__BoHxIiy3__"